/**
 * Card chrome shared by every leaf page under `/account/*` and
 * `/workspace/*`. A title + optional description + bordered body.
 *
 * The `tone="danger"` variant tints the card border red — used by the
 * Danger zone (account delete) and any other destructive surfaces.
 */
export function SettingsSection({
  title,
  description,
  children,
  tone,
}: {
  title: string;
  description?: string;
  children: React.ReactNode;
  tone?: "danger";
}) {
  const isDanger = tone === "danger";
  return (
    <section
      className={`rounded-lg border bg-card ${isDanger ? "border-destructive/40" : ""}`}
    >
      <div
        className={`px-5 py-4 border-b ${
          isDanger ? "border-destructive/30" : "border-border"
        }`}
      >
        <p
          className={`text-sm font-semibold tracking-tight ${
            isDanger ? "text-destructive" : ""
          }`}
        >
          {title}
        </p>
        {description && (
          <p className="text-xs text-muted-foreground mt-0.5">{description}</p>
        )}
      </div>
      <div className="px-5 py-4">{children}</div>
    </section>
  );
}
